module.exports = __webpack_public_path__ + "img/how_it_work_4.dafb527d.png";